import { TASK_STATUSES, TASK_STATUS_LABELS } from '@epasu/core/constants';
import type { TaskStatus } from '@epasu/core/constants';
import { cn } from '@/lib/utils';

/**
 * Zustand einer Aufgabe als Pille, die den nächsten Zustand setzt.
 *
 * Die Farben stehen hier und nicht im Domänenpaket: sie sind
 * Tailwind-Spezifika der Weboberfläche, und `@epasu/core/constants` landet im
 * Browser-Bundle wie im Server.
 */
const FARBEN: Record<TaskStatus, string> = {
  offen: 'bg-slate-100 text-slate-800 hover:bg-slate-200',
  in_arbeit: 'bg-amber-100 text-amber-800 hover:bg-amber-200',
  erledigt: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-200',
};

/** Reihum: offen → in Arbeit → erledigt → offen. */
export function naechsterStatus(status: TaskStatus): TaskStatus {
  const i = TASK_STATUSES.indexOf(status);
  return TASK_STATUSES[(i + 1) % TASK_STATUSES.length] as TaskStatus;
}

export function TaskStatusPill({
  status,
  onWeiter,
}: {
  status: TaskStatus;
  /** Ohne Rückruf ist die Pille nur Anzeige. */
  onWeiter?: (naechster: TaskStatus) => void;
}) {
  const label = TASK_STATUS_LABELS[status] ?? status;
  const klasse = cn(
    'rounded px-2 py-0.5 text-xs font-medium transition-colors',
    FARBEN[status] ?? 'bg-muted text-muted-foreground',
  );

  if (!onWeiter) return <span className={klasse}>{label}</span>;

  const naechster = naechsterStatus(status);
  return (
    <button
      type="button"
      className={klasse}
      title={`Weiter zu „${TASK_STATUS_LABELS[naechster]}“`}
      onClick={(e) => {
        e.stopPropagation();
        onWeiter(naechster);
      }}
    >
      {label}
    </button>
  );
}
